import * as types from './actionTypes';

export  function  initConfig  (familyConfig) {
  return {
    type: types.ADMIN_CONFIG_GET_INIT_CONFIG,
    payload: familyConfig
  };
}

